import React, { Component } from "react";
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: "linear",
};

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabbannerlist: [],
        };
    }

    componentDidMount() {
        const cacheKey = "tabBannerListCache";
        const cacheTTL = 3 * 60 * 60 * 1000;

        const cachedData = JSON.parse(localStorage.getItem(cacheKey));

        if (cachedData && Date.now() - cachedData.timestamp < cacheTTL) {
            this.setState({
                tabbannerlist: cachedData.data || [],
            });
        } else {
            instance
                .get("/api/v1/tabbannerlist?System=" + Systems)
                .then((res) => {
                    if (res.data.status === 200) {
                        this.setState({
                            tabbannerlist: res.data.message || [],
                        });

                        localStorage.setItem(
                            cacheKey,
                            JSON.stringify({
                                timestamp: Date.now(),
                                data: res.data.message || [],
                            })
                        );
                    }
                })
                .catch((err) => {
                    console.error("Error fetching tabbannerlist:", err);
                });
        }
    }

    renderBannerItem = (item, index) => {
        const isVideo =
            item?.bannertype === "video" ||
            /\.(mp4|webm|ogg)$/i.test(item?.path || "");

        return (
            <div key={index}>
                {isVideo ? (
                    <video
                        src={item?.path}
                        autoPlay
                        muted
                        loop
                        playsInline
                        style={{
                            width: "100%",
                            display: "block",
                            borderRadius: "0.5rem",
                        }}
                    />
                ) : (
                    <img
                        className="d-block w-100 border-banner-register"
                        src={item?.path}
                        alt={"Slide " + index}
                        style={{
                            width: "100%",
                            borderRadius: "0.5rem",
                        }}
                    />
                )}
            </div>
        );
    };

    render() {
        const { tabbannerlist } = this.state;

        if (!tabbannerlist || tabbannerlist.length === 0) {
            return null;
        }

        if (tabbannerlist.length === 1) {
            return <>{this.renderBannerItem(tabbannerlist[0], 0)}</>;
        }

        return (
            <>
                <Slider {...settings}>
                    {tabbannerlist.map((item, index) =>
                        this.renderBannerItem(item, index)
                    )}
                </Slider>
            </>
        );
    }
}

export default App;